<!-- Saved, no divergence (design-spec §7 state 7): green banner, paired with the container's toast. -->
@if (result?.status === 'saved') {
  <div class="rp-banner ok" role="status">
    <mat-icon>check_circle</mat-icon>
    <p class="rp-banner-body">
      {{ 'Role saved. Users holding this role pick up the change on their next request.' | translate }}
    </p>
    <button type="button" class="rp-banner-close" (click)="dismiss.emit()"
      [attr.aria-label]="'Dismiss' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<!-- Saved with divergence (design-spec §7 state 8, §8): amber banner naming what the server did not store. -->
@if (result?.status === 'diverged') {
  <div class="rp-banner warn" role="status">
    <mat-icon>warning_amber</mat-icon>
    <div class="rp-banner-body">
      <p class="rp-banner-title">
        {{ 'Saved — but the server changed some of what you sent.' | translate }}
      </p>
      <p class="rp-banner-note">
        {{ 'These objects carry permissions this role is not entitled to, so the server did not store them as sent. The matrix below shows what is actually saved.' | translate }}
      </p>
      <ul class="rp-banner-list">
        @for (object of result?.objects; track trackByIndex($index)) {
          <li>{{ object.name }}</li>
        }
      </ul>
    </div>
    <button type="button" class="rp-banner-close" (click)="dismiss.emit()"
      [attr.aria-label]="'Dismiss' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
